module.exports = __webpack_public_path__ + "static/media/turboventiladores.42da414d.jpg";